import script from "./PlatformMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformMain.vue?vue&type=script&lang=ts&setup=true"

import "./PlatformMain.vue?vue&type=style&index=0&id=51ee1b0a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51ee1b0a"]])

export default __exports__